/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React from "react";
import PropTypes from "prop-types";
import { withNamespaces, Trans } from "react-i18next";

const TableTopBar = ({ selectedCells, availableMinutes, clearSelection, t }) => (
  <div className="dt-toolbar" style={{ padding: `1em`, marginTop: `20px` }}>
    <div className="col-xs-12 col-md-4 col-sm-5 pull-right" style={{ textAlign: `right` }}>
      <label style={{ paddingRight: 10 }}>
        <Trans
          i18nKey="modules.localization.register.authenticated.manualAssignment.availableMinutes"
          values={{
            minutes: availableMinutes || 0
          }}
        >
          <b>
            {t(`modules.localization.register.authenticated.manualAssignment.availableMinutes`)}
          </b>
        </Trans>
      </label>

      <button
        type="button"
        disabled={!selectedCells}
        onClick={clearSelection}
        className="btn btn-default"
      >
        {t(`modules.localization.register.authenticated.manualAssignment.clearSelection`)}
      </button>
    </div>
  </div>
);

TableTopBar.propTypes = {
  selectedCells: PropTypes.bool.isRequired,
  availableMinutes: PropTypes.number,
  clearSelection: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired
};

export default withNamespaces()(TableTopBar);
